import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ReportParameterComponent = ({
  reportParameter,
  reportParameterTypes,
  reportContextParameters,
  onPropertyChanged,
  index,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <Prompt when={reportParameter.changed} message={t('Reports.LeavingWithoutSavingReport')} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={2}>
          <TextField
            label={t('Reports.ReportParameters.ParamName')}
            value={reportParameter.paramName}
            onChange={event => onPropertyChanged('paramName', event, index)}
            error={!isValid(validation[index].paramName)}
            fullWidth
            helperText={getErrors(validation[index].paramName)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Autocomplete
            label={t('Reports.ReportParameters.ReportParameterType')}
            value={reportParameter.reportParameterTypeId}
            simpleValue
            options={reportParameterTypes}
            onChange={event => onPropertyChanged('reportParameterTypeId', event, index)}
            error={!isValid(validation[index].reportParameterTypeId)}
            helperText={getErrors(validation[index].reportParameterTypeId)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <TextField
            label={t('Reports.ReportParameters.FilterCode')}
            value={reportParameter.filterCode || ''}
            fullWidth
            onChange={event => onPropertyChanged('filterCode', event, index)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <TextField
            label={t('Reports.ReportParameters.FilterMember')}
            value={reportParameter.filterMember || ''}
            fullWidth
            onChange={event => onPropertyChanged('filterMember', event, index)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Autocomplete
            label={t('Reports.ReportParameters.ReportContextParameter')}
            labelKey='value'
            valueKey='value'
            value={{ value: reportParameter.reportContextParameter }}
            options={reportContextParameters}
            onChange={event => onPropertyChanged('reportContextParameter', event !== null ? event.value : {}, index)}
          />
        </Grid>
      </Grid>
    </>
  );
};

ReportParameterComponent.propTypes = {
  reportParameter: PropTypes.object,
  reportParameterTypes: PropTypes.array,
  reportContextParameters: PropTypes.array,
  onPropertyChanged: PropTypes.func.isRequired,
  index: PropTypes.number,
  validation: PropTypes.object.isRequired
};

export default ReportParameterComponent;
